export default __webpack_public_path__ + "static/media/banner_chart.05c07df1.svg";